module.exports = __webpack_public_path__ + "static/media/N5.99999397.png";